import type { CoverageDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import { useState } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '@flos/react-ui';
import { useHippoText } from '../../hooks/useHippoText';
import CallMeModal from '../CallMeModal/CallMeModal';
import {
    ACC_DEATH_COVERAGE,
    ACC_HIGH_RISK_SPORT_COVERAGE,
    ACC_IMMEDIATE_COMPENSATION_COVERAGE,
    MVPCOMPREHENSIVE_COV
} from '../../constants/coverage';

const ExcludedCoverageAddButton = ({ coverage }: { coverage: CoverageDTO }): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [showCallMeModal, setShowCallMeModal] = useState(false);

    const getCallMeTitle = (coverage: CoverageDTO): string | undefined => {
        switch (coverage.type) {
            case ACC_DEATH_COVERAGE:
                return getHippoText('DSS-ADD-SIMPLE-COVERAGE-TITLE-CALL-ME', {
                    coverage_name: coverage.name?.toLowerCase() ?? ''
                });
            case ACC_HIGH_RISK_SPORT_COVERAGE:
            case ACC_IMMEDIATE_COMPENSATION_COVERAGE:
                return getHippoText('DSS-ADD-SIMPLE-COVERAGE-HIGH-RISK-SPORT-TITLE-CALL-ME');
            case MVPCOMPREHENSIVE_COV:
                return getHippoText('DSS-CALL-ME-MODAL-MVP-BVR-80-HEADER', {
                    coverage_name: coverage.name?.toLowerCase() ?? ''
                });
            default:
                return undefined;
        }
    };

    const getCallMeDescription = (coverage: CoverageDTO): string | undefined => {
        switch (coverage.type) {
            case ACC_DEATH_COVERAGE:
                return getHippoText('DSS-ADD-SIMPLE-COVERAGE-ACCDEATHCOV-SUMINSURED-CALL-ME');
            case ACC_HIGH_RISK_SPORT_COVERAGE:
                return getHippoText('DSS-ADD-SIMPLE-COVERAGE-HIGH-RISK-SPORT-SUMINSURED-CALL-ME');
            case ACC_IMMEDIATE_COMPENSATION_COVERAGE:
                return getHippoText(
                    'DSS-ADD-SIMPLE-COVERAGE-ACCIMMEDIATECOMPENSATIONCOV-SUMINSURED-CALL-ME'
                );
            case MVPCOMPREHENSIVE_COV:
                return getHippoText('DSS-CALL-ME-MODAL-MVP-BVR-80-SUBHEADER');
            default:
                return undefined;
        }
    };

    return (
        <>
            <Button
                minWidth="widest"
                onClick={() => {
                    setShowCallMeModal(true);
                }}
            >
                {getHippoText('DSS-SHOPPING-BASKET-MISSING-COVERAGES-ADD')}
            </Button>

            {showCallMeModal &&
                createPortal(
                    <CallMeModal
                        showModal={showCallMeModal}
                        closeModal={() => {
                            setShowCallMeModal(false);
                        }}
                        activityCode="dss_call_request"
                        isDefault={false}
                        title={getCallMeTitle(coverage)}
                        description={getCallMeDescription(coverage)}
                    />,
                    document.body
                )}
        </>
    );
};

export default ExcludedCoverageAddButton;
